import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { ReactComponent as TrashCanIcon } from "../../images/trash-can.svg";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { deleteBankDetails } from "services";
import { CustomButton } from "ui";

export const DeleteBankDetails = observer(({ id }: { id: string }) => {
  const { actionModals, bankAccountsStore, user } = useStores();
  const companyId = user.userInfo?.company_id;

  const deleteBankDetailsHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!companyId) return;

    e.stopPropagation();
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Вы уверены, что хотите удалить данные реквизиты?"
          successText="Реквизиты удалены"
          buttonText="Удалить"
          calledQuery={() => deleteBankDetails({ accountId: id, id: companyId })}
          onSuccess={() => {
            setTimeout(() => {
              bankAccountsStore.fetchBankAccounts(companyId);
            }, 1000);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };
  return (
    <CustomButton
      type="link"
      size="small"
      icon={<TrashCanIcon />}
      onClick={deleteBankDetailsHandler}
      tooltip="Удалить реквизиты"
    />
  );
});
